import React from "react";
import { LisaProvider } from "@utdanningsdirektoratet/lisa";
import { breakpoints } from "@utdanningsdirektoratet/lisa-tokens";
import { Header } from "./Header";
import styled from "styled-components";
import { SystemmeldingProvider } from "../../../common/components/systemmeldingContext/SystemmeldingProvider";
import { SystemmeldingApiClient } from "../../generated/clients";
import { Systemomrade } from "apps/elev/generated/types";
import { ErrorStore } from "../Error/ErrorStore";

interface OwnProps {
	hideLogoutButton?: boolean;
}

export const AppContainer = (props: React.PropsWithChildren<OwnProps>) => {
	return (
		<LisaProvider includeSpacing={true} includeGlobalStyling={true}>
			<Header hideLogoutButton={props.hideLogoutButton} />
			<ErrorStore>
				<SystemmeldingProvider
					getSystemmeldingerRequestFunction={(omrade: Systemomrade) =>
						SystemmeldingApiClient.getSystemmeldingerForSystemomrade(omrade)
					}
				>
					<AppWrapper>{props.children}</AppWrapper>
				</SystemmeldingProvider>
			</ErrorStore>
		</LisaProvider>
	);
};

const AppWrapper = styled.main`
	display: block;
	margin: 0 auto;
	max-width: ${breakpoints.px.large};

	padding: 0 80px 0 80px;

	@media (max-width: ${breakpoints.px.small}) {
		padding: 0 24px 0 24px;
	}
`;
